export default function getWeekday(date: number | undefined) {
    if (date === undefined) return '-'
    
    if(date === 0) return 'Domingo';
    if(date === 1) return 'Segunda-feira';
    if(date === 2) return 'Terça-feira';
    if(date === 3) return 'Quarta-feira';
    if(date === 4) return 'Quinta-feira';
    if(date === 5) return 'Sexta-feira';
    if(date === 6) return 'Sábado';
}
